module.exports = __webpack_public_path__ + "img/bar-order-active.975ad5b4.svg";